import { CircularProgress, Grid, Skeleton, Stack, Typography } from "@mui/material";
import { CoinDetailsStyles } from "./styles/Notes.styles";
import StyledTextArea from "./StyledTextArea";
import api from "src/store/features/api";
import { useState } from "react";
import { dateFormatter } from "src/utils/helpers/DateAndTimeHelpers";
import { useMarketsState } from "src/store/features/markets.slice";

export default function Notes() {
  const classes = CoinDetailsStyles();
  const { ticker } = useMarketsState();
  const [isLoading, setIsLoading] = useState(false);
  const {
    data: { timestamp, value } = {},
    refetch,
    isFetching: initialLoading,
  } = api.useGetCoinNoteQuery(
    {
      ticker,
    },
    {
      skip: !ticker,
    },
  );

  const lastEdited = new Date(timestamp || 0);
  const noteFieldIsEmpty = value === undefined || value === "";
  const editedPlaceHolder = noteFieldIsEmpty
    ? "Edited --/--/--"
    : `Edited ${dateFormatter(lastEdited, true, true)}`;

  const NotesFooter = () => {
    return (
      <div id="noteSection">
        <Stack
          justifyContent={"space-between"}
          direction={"row"}
          display="flex"
          sx={{ margin: "12px 2px 0px 4px", alignSelf: "baseline" }}>
          <Typography className={classes.edited}>{editedPlaceHolder}</Typography>
          {isLoading && (
            <Stack direction={"row"} spacing={1}>
              <Typography className={classes.saving}>Saving</Typography>
              <CircularProgress size={15} sx={{ color: "#9CA3A8" }} />
            </Stack>
          )}
        </Stack>
      </div>
    );
  };

  return (
    <>
      <Grid className={classes.layout}>
        {initialLoading ? (
          <Skeleton variant="rectangular" height={200} />
        ) : (
          <>
            <StyledTextArea setIsLoading={setIsLoading} value={value} refetch={refetch} />
            <NotesFooter />
          </>
        )}
      </Grid>
    </>
  );
}
